import clsx from 'clsx';

import { PAYMENT_METHODS } from '@/features/payment/const';
import { BagIcon, ChartPieSliceIcon, PercentIcon } from '@/shared/ui/icon';

import { usePaymentStore } from '../../../store';
import { PaymentMethodsDataType } from '../../../types';

const iconMap: Record<string, React.ElementType> = {
	bag: BagIcon,
	percent: PercentIcon,
	'chart-pie-slice': ChartPieSliceIcon,
};

interface PaymentMethodSelectorProps {
	courseName: string;
	paymentMethodsData: PaymentMethodsDataType[];
	benefitPercentForFullPayment: number | null;
	benefitPercentForDolyamiPayment: number | null;
	isSubscription: boolean;
}

export const PaymentMethodSelector = ({
	courseName,
	paymentMethodsData,
	benefitPercentForFullPayment,
	benefitPercentForDolyamiPayment,
	isSubscription,
}: PaymentMethodSelectorProps) => {
	const { values: formValues, updateValues } = usePaymentStore();

	return (
		<div className="w-full md:w-1/2">
			<div className="flex pb-3 pt-8 text-lg font-bold text-gray-1 md:hidden">
				{isSubscription ? `Подписка` : `Курс "${courseName}"`}
			</div>
			<h2 className="mb-3 text-lg font-semibold tracking-[0.1px] text-gray-3">
				Выберите удобный вариант
			</h2>

			<div className="space-y-4">
				{paymentMethodsData.map((option) => (
					<div
						key={option.id}
						className={clsx(
							'flex cursor-pointer items-center justify-between gap-4 rounded-xl p-6 transition-all duration-300',
							option.id === formValues.paymentMethod && 'ring-2 ring-gray-1',
							option.id !== formValues.paymentMethod && 'ring-1 ring-gray-4',
						)}
						onClick={() => updateValues({ paymentMethod: option.id })}
					>
						<div className="flex items-center gap-4">
							{(() => {
								const Icon = iconMap[option.icon];
								return Icon ? <Icon className="size-8 text-gray-2" /> : null;
							})()}
							<span className="text-[20px] font-medium">{option.title}</span>
						</div>

						{option.id === PAYMENT_METHODS.FULL &&
						benefitPercentForFullPayment ? (
							<span className="shrink-0 rounded-lg bg-green-100 px-2 py-1">
								<span className="text-[12px] font-semibold text-green">
									{`Выгода ${benefitPercentForFullPayment}%`}
								</span>
							</span>
						) : null}
						{option.id === PAYMENT_METHODS.DOLYAMI &&
						benefitPercentForDolyamiPayment ? (
							<span className="shrink-0 rounded-lg bg-green-100 px-2 py-1">
								<span className="text-[12px] font-semibold text-green">
									{`Выгода ${benefitPercentForDolyamiPayment}%`}
								</span>
							</span>
						) : null}
					</div>
				))}
			</div>
		</div>
	);
};
